import React from 'react';
import { Card, Modal, Row, Typography } from 'antd';

import { ColpromiseResponse } from 'services/collection';
import moment from 'moment';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { isNil } from 'lodash';
import { useTranslation } from 'react-i18next';
import { toCurrency } from 'utils/utils';

type colPromiseModalProps = {
  data: ColpromiseResponse;
  visible: boolean;
  onClose: () => void;
  type: 'PROM' | 'COMM';
};

const ColPromiseModal = (props: colPromiseModalProps) => {
  const { data, onClose, visible, type } = props;
  const { t } = useTranslation();

  return (
    (<Modal
      title={<GetLabel label={type === 'COMM' ? 'ColComment' : 'ColPromise'} />}
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      width={600}
    >
      <Card>
        {type === 'COMM' ? (
          <>
            <Row gutter={[32, 32]}>
              <Typography.Text strong>{data?.username}</Typography.Text>&nbsp;
              {t('colcommented')}
              <Typography.Text strong>
                &nbsp;
                {!isNil(data?.promcreationdate)
                  ? moment(data?.promcreationdate).format('YYYY-MM-DD') + ':'
                  : ':'}
              </Typography.Text>
            </Row>
            <Typography.Paragraph>
              <b>
                <blockquote>{data?.promcomment}</blockquote>
              </b>
            </Typography.Paragraph>
          </>
        ) : (
          <>
            <Row gutter={[32, 32]}>
              <b>{data?.username}</b>&nbsp;
              <GetLabel label="addedanewpromise" />
              &nbsp;
              <b>
                {' '}
                {!isNil(data?.promcreationdate)
                  ? moment(data?.promcreationdate).format('YYYY-MM-DD')
                  : ''}
                :
              </b>
            </Row>
            <Typography.Paragraph>
              <blockquote>
                <b>{data?.tpname}</b>&nbsp;
                <GetLabel label="makecommit" />
                &nbsp;<b>{data?.promtypelabel}</b>&nbsp;
                <GetLabel label="topaythesum" />
                &nbsp;<b>{toCurrency(data?.promamount, localStorage.getItem('currcode') ?? '')}</b>&nbsp;
                <GetLabel label="on" />
                &nbsp;<b>{data?.promdate}</b>&nbsp;{' '}
                {!isNil(data.ciid) ? (
                  <>
                    <GetLabel label="relatedto" />
                    &nbsp;<b>{data.cireference}</b>
                  </>
                ) : (
                  ''
                )}
              </blockquote>
            </Typography.Paragraph>
          </>
        )}
      </Card>
    </Modal>)
  );
};

export default ColPromiseModal;
